// extracted by mini-css-extract-plugin
module.exports = {"switcher":"styles_switcher__3WIxd","flag":"styles_flag___Fjdp","active":"styles_active__OhNrH","disabled":"styles_disabled__BRo75","ukraine":"styles_ukraine__2EMrq"};